"use client";

import clsx from "clsx";

import inputStyles from "./Input.module.scss";
import PhoneCountrySelect from "./PhoneCountrySelect";
import styles from "./PhoneInputField.module.scss";

export default function PhoneInputField({
  id,
  name,
  label,
  locale,
  value = "",
  onChange,
  error,
  required = false,
  disabled = false,
  country,
  onCountryChange,
  inputMode = "tel",
  autoComplete = "tel",
  className,
  inputProps,
  searchPlaceholder,
  emptyLabel,
}) {
  const inputId = id || name;
  const isFilled = Boolean(value && String(value).trim().length);

  return (
    <div
      className={clsx(
        inputStyles.input,
        styles.root,
        className,
        isFilled && inputStyles.filled,
        isFilled && styles.filled,
        error && styles.error,
        disabled && styles.disabled
      )}
    >
      <div className={styles.field}>
        <PhoneCountrySelect
          locale={locale}
          country={country}
          onCountryChange={onCountryChange}
          disabled={disabled}
          compact
          searchPlaceholder={searchPlaceholder}
          emptyLabel={emptyLabel}
        />
        <input
          id={inputId}
          name={name}
          type="tel"
          value={value}
          onChange={onChange}
          disabled={disabled}
          required={required}
          inputMode={inputMode}
          autoComplete={autoComplete}
          className={styles.input}
          placeholder=" "
          {...inputProps}
        />
      </div>
      <label htmlFor={inputId}>{label}</label>
      {error && (
        <p id={`${inputId}-error`} className={inputStyles.errorText} role="alert">
          {error}
        </p>
      )}
    </div>
  );
}
